import { GetCommissionCashbackByIdResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { CommissionCashbackQueryKeys } from '@/modules/promotion/keys'
import { getCommissionCashbackById } from '../../services'

export default function useQueryGetCommissionById(
	id: string,
	props?: UseBaseQueryOptions<GetCommissionCashbackByIdResponse>,
) {
	return useQuery({
		queryKey: [CommissionCashbackQueryKeys.GetCommissionCashbackById, id],
		queryFn: () => getCommissionCashbackById(id),
		...props,
	})
}
